var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFinancingFee = function SvgFinancingFee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 42 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M4.278 6.278A5.333 5.333 0 0 1 9.61.944h19.63c1.637 0 3.183.752 4.194 2.039l7.036 8.956c.739.94 1.14 2.1 1.14 3.294v23.045a5.333 5.333 0 0 1-5.333 5.333H9.61a5.333 5.333 0 0 1-5.333-5.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeWidth: 3.556,
    d: "M14.944 13.389h7.111M14.944 22.278h16M20.778 31.222h10.444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M8.834 47.056a8.444 8.444 0 1 0 0-16.89 8.444 8.444 0 0 0 0 16.89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    fillRule: "evenodd",
    d: "M10.248 35.119c.304 0 .606.05.892.15a.698.698 0 1 0 .458-1.32 4.1 4.1 0 0 0-1.4-.226 4.73 4.73 0 0 0-4.156 2.926h-1.4a.698.698 0 0 0 0 1.397h1.062q-.024.282-.013.566-.01.283.013.564H4.643a.698.698 0 0 0 0 1.397h1.399a4.73 4.73 0 0 0 4.186 2.928 4.2 4.2 0 0 0 1.676-.344.699.699 0 0 0-.554-1.282c-.348.15-.723.228-1.103.229a3.33 3.33 0 0 1-2.637-1.53h1.224a.698.698 0 0 0 0-1.397H7.108a3.3 3.3 0 0 1-.02-.536v-.058a3 3 0 0 1 .02-.536h1.726a.698.698 0 1 0 0-1.397H7.61a3.33 3.33 0 0 1 2.638-1.531",
    clipRule: "evenodd"
  })));
};
export default SvgFinancingFee;